import Image from "react-bootstrap/Image";
import ApiHelper from "../../Helpers/ApiHelper";
import { folderEnum } from "../../Helpers/EnumHelper";
import IconSvg from "./IconSvg";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

const ProfilePicture = ({ profilePicFileName, userId, size, googleProfilePic }) => {
  return (
    <div
      className={"rounded-circle align-content-center border border-1 border-gray overflow-hidden"}
      style={{ height: `${size}px`, width: `${size}px`, padding: "0px" }}
    >
      {Boolean(profilePicFileName) ? (
        <Image
          src={ApiHelper.cloudFrontURL + folderEnum.profile + profilePicFileName}
          alt={"userProfilePic"}
          className={"h-100 w-100 p-0"}
        />
      ) : googleProfilePic ? (
        <Image src={googleProfilePic} alt="avatar" className={"h-100 w-100 p-0"} />
      ) : userId ? (
        <Image
          src={`https://api.dicebear.com/9.x/bottts/svg?seed=${userId}&backgroundColor=ffffff`}
          alt="avatar"
          className={"h-100 w-100 p-0"}
        />
      ) : (
        <Row className={"justify-content-center h-100"}>
          <Col xs={"auto"} className={"align-content-center"}>
            <IconSvg icon={"candidate"} height={size * (28 / 65)} width={size * (25 / 65)} />
          </Col>
        </Row>
      )}
    </div>
  );
};
export default ProfilePicture;
